import React, { useCallback, useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import BusinessLogo from "../assets/images/Logo.png";
import useHttp from "../hooks/use-http";

const CardNavigation = () => {
  const [merchantLogo, setMerchantLogo] = useState();
  const { sendRequest: MerchantInfo } = useHttp();

  const { id } = useParams();

  const getMerchantInfo = (data) => {
    if (data?.data?.logo) {
      setMerchantLogo(data?.data?.logo);
    } else {
      setMerchantLogo(BusinessLogo);
    }
  };

  console.log(merchantLogo, 'merchantLogo')

  const fetchMerchantInfo = useCallback(async () => {
    MerchantInfo(
      {
        url: `${process.env.REACT_APP_BASE_URL}/api/transaction/merchant/${id}`,
        headers: {
          "Content-Type": "application/json",
        },
      },
      getMerchantInfo
    );
  }, [MerchantInfo, id]);

  useEffect(() => {
    const fetchData = async () => {
      await fetchMerchantInfo();
    };

    fetchData();
  }, [fetchMerchantInfo]);

  return (
    <div className="min-h-screen bg-[#5d7c8f] bg-blend-overlay flex items-center justify-center p-0 md:p-8 bg-cover bg-no-repeat bg-center bg-[url('../src/assets/images/background.png')] font-sans">
      {/* Centered Desktop Card Box */}
      <div className="w-full max-w-[780px] bg-white rounded-none shadow-none flex overflow-hidden min-h-[650px] border border-slate-200 hidden md:flex md:scale-[0.85] lg:scale-[0.9] origin-center">
        {/* Left Sidebar */}
        <div className="w-[220px] bg-[#f4faff] border-r border-slate-200 flex flex-col justify-between hidden md:flex">
          <div>
            {/* Merchant Logo */}
            <div className="p-6 border-b border-slate-200/60 bg-white">
              <img
                src={merchantLogo}
                alt="logo"
                className="h-[40px] w-auto object-contain mx-auto"
              />
            </div>
            {/* Payment Options title & link */}
            <div className="mt-8 px-4">
              <h1 className="text-xs font-extrabold text-slate-400 uppercase tracking-wider mb-3">
                Payment Options
              </h1>
              <div className="flex items-center gap-3 p-4 rounded-xl bg-[#00aeef] text-white shadow-md shadow-[#00aeef]/10">
                <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <rect x="2" y="5" width="20" height="14" rx="2" ry="2"></rect>
                  <line x1="2" y1="10" x2="22" y2="10"></line>
                  <line x1="6" y1="15" x2="10" y2="15"></line>
                </svg>
                <span className="text-sm font-extrabold">Card</span>
              </div>
            </div>
          </div>

          {/* Powered by logo */}
          <div className="p-5 border-t border-slate-200/60 bg-white flex justify-center">
            <div className="px-4 py-2 border border-slate-200 rounded-lg bg-white flex items-center justify-center gap-2">
              <svg width="10" height="12" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="5" width="14" height="11" rx="2" fill="#f5a623" />
                <path d="M3 5V4.5C3 2.567 4.567 1 6.5 1V1C8.433 1 10 2.567 10 4.5V5" stroke="#f5a623" strokeWidth="2" strokeLinecap="round" />
                <circle cx="7" cy="10.5" r="1.5" fill="white" />
              </svg>
              <span className="text-[9px] text-slate-500 font-extrabold uppercase tracking-widest leading-none">
                Powered by Payloft
              </span>
            </div>
          </div>
        </div>

        {/* Right Content Area */}
        <div className="flex-1 flex flex-col justify-between bg-white relative">
          <div className="flex-1 p-5 overflow-y-auto bg-white flex flex-col justify-center">
            <Outlet />
          </div>
        </div>
      </div>

      {/* Mobile Screen View */}
      <div className="w-full min-h-screen bg-white flex flex-col md:hidden">
        {/* Top Header Bar */}
        <div className="h-[60px] border-b border-slate-200 flex items-center justify-between px-4 bg-white relative">
          <div className="w-10"></div>
          <span className="text-lg font-bold text-slate-800 absolute left-1/2 transform -translate-x-1/2">
            Payment
          </span>
          <div className="w-10"></div>
        </div>

        {/* Form Content */}
        <div className="flex-1 p-5 overflow-y-auto bg-white flex flex-col justify-between">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default CardNavigation;
